import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IUploadFile, IUploadFileCompleteEvent, IUploadFormData } from '../multi-file-upload/multi-file-upload.component';
import { IDialogButton } from '../message/ga-message.service';
import { TranslationService } from '../translation/translation.service';

@Component({
  selector: 'upload-files-dialog',
  template: `
    <default-dialog [buttons]="buttons" [title]="title" [closeButton]="true" (onClose)="onCancel.emit()">
      <multi-file-upload
        [path]="postUrl"
        [uploading]="uploading"
        [filesAccepted]="filesAccepted"
        [showButtons]="false"
        [uploadFormData]="uploadFormData"
        (onQueueChange)="onQueueChange($event)"
        (onUploadCompleted)="onUploadCompleted.emit($event)"
        (onUploadCancelled)="onUploadCancelled()"
        (onUploadError)="onUploadError()">
      </multi-file-upload>
    </default-dialog>
  `
})
export class UploadFilesDialogComponent implements OnInit {
  @Input() public title:string;
  @Input() public postUrl:string;
  @Input() public filesAccepted:string[];
  @Input() public addLabel:string;
  @Input() public uploadFormData?:IUploadFormData;

  @Output() public onCancel:EventEmitter<void> = new EventEmitter<void>();
  @Output() public onUploadCompleted:EventEmitter<IUploadFileCompleteEvent> = new EventEmitter<IUploadFileCompleteEvent>();

  public uploading:boolean;
  public buttons:IDialogButton[];

  private filesCount:number = 0;

  constructor(
    private cdr:ChangeDetectorRef,
    private translationService:TranslationService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.buttons = [
      {
        label: this.translationService.instant('GA.BUTTONS.ADD_LABEL', { label: this.addLabel }),
        className: 'btn btn-success',
        disabled: this.uploading || !this.filesCount,
        onClick: this.startUpload,
        busy: false
      },
      {
        label: this.translationService.instant('GA.BUTTONS.CANCEL'),
        onClick: () => this.onCancel.emit()
      }
    ];
  }

  public onQueueChange(files:IUploadFile[]):void {
    this.filesCount = files?.length || 0;
    this.onStartUploadButtonChange();
  }

  public onUploadCancelled():void {
    this.uploading = false;
    this.onCancel.emit();
  }

  public onUploadError():void {
    this.uploading = false;
    this.onStartUploadButtonChange();
  }

  private startUpload = ():void => {
    this.uploading = true;
    this.onStartUploadButtonChange();
  };

  private onStartUploadButtonChange():void {
    this.buttons[0].disabled = this.uploading || !this.filesCount;
    this.buttons[0].busy = this.uploading;

    // Trigger change detection to ensure dialog buttons are updated immediately
    this.cdr.detectChanges();
  }
}